import Layout from '../../components/Layout/Main';
import Content from '../../components/Pages/Plans';
import { displayName } from '../../config';

const Plans = (): JSX.Element => {
  document.title = `${displayName}: Plans`;

  return (
    <Layout>
      <Content />
    </Layout>
  );
};

export default Plans;
